<template>
    <div class="row">
        <div class="row" v-for="group in precinctGroups" :key="group.name">
            <div class="col col-sm-12">
                <ul class="nav small-nav nav-pills">
                    <li class="nav-group">
                        <h5>{{ group.name }}:</h5>
                    </li>
                    <li class="nav-item small" v-for="pct in group.precincts" :key="pct">
                        <router-link class="nav-link"
                            :class="{ 'active': pct.Precinct == precinct, 'favorite': isFavorite(pct.Precinct) }"
                            :title="`Precinct ${pct.PRECINCT_NAME} details`"
                            :to="{ name: 'precinct', params: { state: state, county: county, precinct: pct.Precinct } }">
                            {{ pct.Precinct }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
// import { ref } from 'vue';
// import { shallowRef } from 'vue';
import { useCountyStore } from '@/common/stores/countyStore';

export default {
    props: ['currentUserPreferences', 'currentUserRoles'],
    components: {},
    mounted() {
        this.showPrecinctsList = !this.precinct;
    },
    data() {
        return {
            precinctsList: [],
        }
    },
    methods: {
        isFavorite(pct) {
            return this.currentUserPreferences.favoritePrecincts.includes(pct);
        }
    },
    computed: {
        precinctGroups() {
            return useCountyStore().precinctGroups
        },
        precincts() {
            return useCountyStore().precincts;
        },
        county() {
            return useCountyStore().county
        },
        state() {
            return useCountyStore().countyState
        },
        /**
         * Returns the current precinct from the route.
         *
         * @returns {String} The current precinct.
         */
        precinct() {
            return this.$route.params.precinct;
        }
    }
}
</script>

<style>
span.badge {
    margin: 0.5em;
}

.icon {
    cursor: pointer;
}

li a.favorite::after {
    content: "\2764\fe0f";
    position: relative;
    top: -0.5em;
    font-size: 60%;
}

.nav-group h5 {
    margin-bottom: 0.5em;
    color: var(--bs-primary);
}
</style>
